import { Box, Heading } from 'native-base';
import React, { ReactNode } from 'react';

import { DEFAULT_PADDING } from 'app/components/ResponsiveContainer';

export type GroupTitleProps = {
  children?: ReactNode;
};

export default function GroupTitle({ children }: GroupTitleProps) {
  return (
    <Box bg="black:alpha.40" mx={`-${DEFAULT_PADDING}`} px={DEFAULT_PADDING} testID="GroupTitle">
      <Heading color="white" fontSize="md" py="1.5">
        {children}
      </Heading>
    </Box>
  );
}
